/***********
NavBar
Barra de navegacao
**************/

//Imports
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink, useNavigate } from 'react-router-dom';
import { useSignOut, useAuthUser } from 'react-auth-kit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket, faScrewdriverWrench, faMoon, faSun, faBook } from '@fortawesome/free-solid-svg-icons'
import './navBar.css';

// O componente
export default function NavBar({subname, darkMode, setDarkMode, selectedModel, onChangeModel}) {
    const signOut = useSignOut();
    const navigate = useNavigate();
    const auth = useAuthUser();
    const logout = () => {
        signOut();
        navigate("/login");
    }
    return (
        <nav className="navbar p-0">
            <div className="nav-inner">
                <div className="nav-brand-area">
                    <NavLink className="navbar-brand" to="/app">
                        <img alt="Logo HealthPad" className="navlogo" src="/logo192.png" />
                        <span className="navsub">HealthPad</span>
                    </NavLink>
                    {subname && <span className="navsub2">&gt; <span>{subname}</span></span>}
                </div>
                <div className="nav-actions">
                    <span className="user-name">{auth().name}</span>
                    {selectedModel && onChangeModel && (
                        <select
                            className="model-selector"
                            value={selectedModel}
                            onChange={(e) => onChangeModel(e.target.value)}
                        >
                            <option value="gpt-5.4-mini">gpt-5.4-mini</option>
                            <option value="gpt-5.4">gpt-5.4</option>
                            <option value="gpt-5.6-luna">gpt-5.6-luna</option>
                            <option value="gpt-5.6-terra">gpt-5.6-terra</option>
                        </select>
                    )}
                    <label className="theme-switch ms-2">
                        <input type="checkbox" checked={darkMode} onChange={() => setDarkMode(!darkMode)} />
                        <span className="slider"></span>
                        <FontAwesomeIcon icon={faMoon} className="moon" />
                        <FontAwesomeIcon icon={faSun} className="sun" />
                    </label>

                    {auth().role === "admin" && (
                    <OverlayTrigger
                        placement="bottom" 
                        overlay={<Tooltip id='ttadmin'>
                            <span className='color-white'>Admin Panel</span></Tooltip>}>
                        <FontAwesomeIcon className="mx-1 mx-lg-2 cursor logout" onClick={() => navigate("/admin")} icon={faScrewdriverWrench} inverse/>
                    </OverlayTrigger>
                    )}
                    <OverlayTrigger
                        placement="bottom" 
                        overlay={<Tooltip id='ttnotepad'>
                            <span className='color-white'>Notepad</span></Tooltip>}>
                        <FontAwesomeIcon className="mx-1 mx-lg-2 cursor logout" onClick={() => window.open("/notepad", "_blank", "noopener,noreferrer")} icon={faBook} inverse/>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="bottom" 
                        overlay={<Tooltip className='color-white' id='ttlogout'>
                                 <span className='color-white'>Sair</span></Tooltip>}>
                        <FontAwesomeIcon className="mx-1 mx-lg-2 cursor logout" onClick={() => logout()} icon={faRightFromBracket} inverse/>
                    </OverlayTrigger>
                </div>
            </div>
        </nav>
        
         
    );
}
